import { useEffect } from "react";

/**
 * Mises à jour automatiques : dès qu'un nouveau service worker est prêt,
 * on l'applique immédiatement sans rien demander à l'utilisateur.
 * Le reload est déclenché par `controllerchange` dans registerPWA.
 */
const PwaUpdatePrompt = () => {
  useEffect(() => {
    const apply = () => {
      window.__applyPwaUpdate?.().catch(() => {
        window.__forcePwaReset?.();
      });
    };
    window.addEventListener("pwa:update-available", apply);
    return () => window.removeEventListener("pwa:update-available", apply);
  }, []);

  return null;
};

export default PwaUpdatePrompt;
